var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2444",
    d: "M7.69025 3.66874C7.69025 5.14263 6.49539 6.33749 5.02151 6.33749C3.54747 6.33749 2.3526 5.14263 2.3526 3.66874C2.3526 2.19486 3.54747 0.999996 5.02151 0.999996C6.49539 0.999996 7.69025 2.19486 7.69025 3.66874Z",
    stroke: "#929292",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2448",
    d: "M9.00656 11C9.03096 10.823 9.043 10.6417 9.043 10.4579C9.043 8.23694 7.24256 6.43635 5.02158 6.43635C2.80059 6.43635 1 8.23694 1 10.4579C1 10.6417 1.0122 10.823 1.03644 11",
    stroke: "#929292",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2452",
    d: "M9.0065 11H1.03638",
    stroke: "#929292",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdIcon);
export default __webpack_public_path__ + "static/media/id-icon.3c89462c5708aad1dfc20930f86f6c44.svg";
export { ForwardRef as ReactComponent };